// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3X1P6","title":"Header_title__2Gaob","left":"Header_left__2Zqmr","clinicName":"Header_clinicName__2WEbs"};